export enum ShopGoodAccessStatus {
	Available = "available",
	Active = "active",
	CoveredByAnnual = "covered_by_annual",
	UpgradeToAnnual = "upgrade_to_annual",
}
